import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import RadioButtons from 'components/RadioButtons';
import styles from 'styles/input.scss';
import TextArea from 'components/TextArea';

import S from 'modal.scss';
import { addEventToPhase, clearValidation } from 'actionCreators/phase';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../reducers';

class CheckinModal extends Resetter(Validator(React.Component)) {
  static OPTIONS = [
    {
      label: 'I\'ve arrived at the Jobsite',
      value: 'arrived',
    },
    {
      label: 'I\'ve left the Jobsite',
      value: 'left',
    },
  ];
  static DEFAULT_STATE = {
    kind: 'arrived',
    note: '',
    errors: {},
  }
  static VALIDATIONS = { kind: true }

  handleKindChange = (e) => {
    this.setState({
      kind: e,
    });
  }

  handleNoteChange = (e) => {
    this.setState({
      note: e.target.value,
    });
  }

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
  }

  handleSubmit = () => {
    if (!this.validate()) return;
    const phase = this.props.phase;
    const { kind, note } = this.state;

    const noteProps = {
      name: kind === 'arrived' ? 'Installer On Jobsite' : 'Installer Left Jobsite',
      kind: 'checkin',
      data: { kind, note },
    };

    this.props.addEventToPhase(phase.id, noteProps).then(() => {
      this.handleClose();
    });
  }

  handleConfirmClose = () => {
    this.handleClose();
  }

  render() {
    const { active, serverErrors } = this.props;
    const { kind, note, errors } = this.state;

    return (
      <Dialog
        active={active}
        className={S.modal}
        type="fullscreen"
        onEscKeyDown={this.handleClose}
        onOverlayClick={this.handleClose}
      >
        <div className={styles.errored}>
          {Object.keys(serverErrors).length > 0 &&
            <span className={styles.error}>This action could not be completed.</span>}
        </div>

        <IconButton
          icon="close"
          className={S.close}
          onClick={this.handleClose}
          tabIndex={-1}
        />

        <h5 className={S.title}>Check In/Out</h5>

        <RadioButtons
          text={`Please select if you've arrived or are leaving the jobsite. If
            performing a multiple day installation, please repeat each day.
            Include any important notes about the jobsite.`}
          required
          onChange={this.handleKindChange}
          selectedValue={kind}
          radioButtons={CheckinModal.OPTIONS}
        />

        <TextArea
          label="Notes about Jobsite"
          value={note}
          errors={errors.note}
          onChange={this.handleNoteChange}
        />

        <Button
          label="Submit"
          flat inverse ripple
          className={S.submit}
          onClick={this.handleSubmit}
        />
      </Dialog>
    );
  }
}

CheckinModal.propTypes = {
  active: PropTypes.bool.isRequired,
  addEventToPhase: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  serverErrors: PropTypes.shape({}),
};

CheckinModal.defaultProps = {
  active: false,
};

export default connect(
  state => ({ serverErrors: getPhaseErrors(state) }),
  { addEventToPhase, clearValidation },
)(CheckinModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/checkinModal.jsx